import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import * as api from "../../api/index";

export default function FeedbackPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
    rating: 0,
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submitFeedback = async () => {
    try {
      if (!form.name.trim() || !form.message.trim()) {
        setStatus("⚠️ Name and message are required.");
        return;
      }
      setLoading(true);
      const res = await api.postfeedback(form);
      if (res.data.success) {
        setStatus("✅ Thank you! Your feedback was submitted.");
        setForm({ name: "", email: "", message: "", rating: 0 });
        setTimeout(() => navigate(-1), 1500); // go back after success
      } else {
        setStatus("❌ Something went wrong.");
      }
    } catch (err) {
      setStatus("❌ Failed to submit feedback.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Top header with back button */}
      <div className="w-full p-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-700 hover:text-gray-900"
        >
          <IoMdArrowBack size={24} />
          <span className="ml-1">Back</span>
        </button>
      </div>

      {/* Centered white card */}
      <div className="flex flex-1 items-center justify-center p-4">
        <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-md">
          <h1 className="text-2xl font-bold mb-6 text-center">Leave Feedback</h1>

          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Your Name *"
            className="w-full p-3 border rounded-lg mb-3"
          />

          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Your Email (optional)"
            className="w-full p-3 border rounded-lg mb-3"
          />

          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Write your feedback here..."
            className="w-full p-3 border rounded-lg mb-3"
            rows="4"
          />

          {/* Rating stars */}
          <div className="flex items-center gap-2 mb-4">
            <span className="text-gray-600">Rate us:</span>
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                type="button"
                key={star}
                onClick={() => setForm({ ...form, rating: star })}
                className={`text-2xl ${
                  form.rating >= star ? "text-yellow-400" : "text-gray-300"
                }`}
              >
                ★
              </button>
            ))}
          </div>

          <button
            onClick={submitFeedback}
            disabled={loading}
            className={`${
              loading ? "bg-gray-400" : "bg-orange-500 hover:bg-orange-600"
            } text-white px-6 py-2 rounded-xl w-full`}
          >
            {loading ? "Submitting..." : "Submit Feedback"}
          </button>

          {status && (
            <p className="mt-3 text-center text-sm text-gray-700">{status}</p>
          )}
        </div>
      </div>
    </div>
  );
}
